var api = require("!../../node_modules/_style-loader@1.1.3@style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../node_modules/_css-loader@3.4.2@css-loader/dist/cjs.js??ref--5-1!../../node_modules/_postcss-loader@3.0.0@postcss-loader/src/index.js??ref--5-2!../../node_modules/_sass-loader@8.0.2@sass-loader/dist/cjs.js!./index.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;